import React ,{useEffect,useState} from 'react'
import { useParams } from "react-router-dom";
import Student912TopMenu from "../studentInfo/student12topmenu"
import { getIdData } from "../../../lib/studentinfo";
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function index() {
    let { slug } = useParams();
    const [studentInfo, setStudentInfo] = useState();
    const { profile, setProfile } = useAuth();

    async function GetStudentData() {
        const std = await getIdData(slug);
        setStudentInfo(std);
        //console.log("std", std);   
      }

useEffect(() => {
    //GetStudentData();
}, [slug])


  return (
    <>
    <Student912TopMenu slug={slug} activeMenu={"Lor"} />
      <PageNotes
        type={"Instructor"}
        pageName={"Lor 12"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
        <div className="col-md-12 vh-100">
            
        <div className='d-flex justify-content-center'>
        <h1 className='mt-5'>Coming Soon</h1>
        </div>
 
        </div>
        </div>
      </div>
      </>
  );

}
